import { createVNode as _createVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h3", { class: "card-title fw-bolder text-white" }, "Sales Progress", -1)
const _hoisted_2 = { class: "card-toolbar" }
const _hoisted_3 = { class: "svg-icon svg-icon-2" }
const _hoisted_4 = { class: "card-body p-0" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"card-rounded bg-body mt-n10 position-relative card-px py-15\"><div class=\"row g-0 mb-7\"><div class=\"col mx-5\"><div class=\"fs-6 text-gray-400\">Avarage Sale</div><div class=\"fs-2 fw-bolder text-gray-800\">$650</div></div><div class=\"col mx-5\"><div class=\"fs-6 text-gray-400\">Comissions</div><div class=\"fs-2 fw-bolder text-gray-800\">$29,500</div></div></div><div class=\"row g-0\"><div class=\"col mx-5\"><div class=\"fs-6 text-gray-400\">Revenue</div><div class=\"fs-2 fw-bolder text-gray-800\">$55,000</div></div><div class=\"col mx-5\"><div class=\"fs-6 text-gray-400\">Expenses</div><div class=\"fs-2 fw-bolder text-gray-800\">$1,130,600</div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown3 = _resolveComponent("Dropdown3")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _createVNode("div", {
      class: [`bg-${_ctx.widgetColor}`, "card-header border-0 py-5"]
    }, [
      _hoisted_1,
      _createVNode("div", _hoisted_2, [
        _createVNode("button", {
          type: "button",
          class: [`btn-active-color-${_ctx.widgetColor}`, "\n            btn btn-sm btn-icon btn-color-white btn-active-white\n            border-0\n            me-n3\n          "],
          "data-kt-menu-trigger": "click",
          "data-kt-menu-placement": "bottom-end"
        }, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
          ])
        ], 2),
        _createVNode(_component_Dropdown3)
      ])
    ], 2),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_apexchart, {
        class: [`bg-${_ctx.widgetColor}`, "mixed-widget-12-chart card-rounded-bottom"],
        options: _ctx.chartOptions,
        series: _ctx.series,
        height: "200",
        type: "bar"
      }, null, 8, ["class", "options", "series"]),
      _hoisted_5
    ])
  ], 2))
}